export default __webpack_public_path__ + "1797fad3d174be471045bd17af235840.svg";